var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12 col-md-4 col-md-offset-4" }, [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(
                _vm.$t(
                  "MAIN_CONTENT.InteractiveScheduler.useThisScreenToChangeClassSchedule"
                )
              ) +
              "\n\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12 col-md-4 col-md-offset-4" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedClass,
                  expression: "selectedClass"
                }
              ],
              staticClass: "form-control",
              attrs: { name: "scheduleList" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selectedClass = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c("option", { attrs: { value: "" } }, [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(
                      _vm.$t(
                        "MAIN_CONTENT.InteractiveScheduler.selectScheduleToAccess"
                      )
                    ) +
                    "\n\t\t\t\t"
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.classList, function(classlist, classIndex) {
                return _c(
                  "option",
                  {
                    key: "class_" + classIndex,
                    domProps: { value: classlist.ISCHED_VIEW_CODE }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(classlist.SCHOOL_TITLE) +
                        " - " +
                        _vm._s(classlist.ISCHED_VIEW_DESC) +
                        "\n\t\t\t\t"
                    )
                  ]
                )
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        !!_vm.selectedClass && _vm.printLink
          ? _c("div", { staticClass: "col-xs-12 col-md-2 col-md-offset-2" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-primary",
                  attrs: { target: "_blank", href: _vm.printLink }
                },
                [
                  _c("i", {
                    staticClass: "fas fa-print",
                    attrs: { "aria-hidden": "true" }
                  }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("MAIN_CONTENT.InteractiveScheduler.print")
                      ) +
                      "\n\t\t\t\t"
                  ),
                  _c("aria-new-tab-message", {
                    attrs: {
                      message: _vm.$t(
                        "MAIN_CONTENT.Accessibility.opensInNewTab"
                      )
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      !!_vm.messages
        ? _vm._l(_vm.messages, function(message, messageIndex) {
            return _c(
              "div",
              {
                key: "message_" + messageIndex,
                attrs: { "aria-live": "polite" }
              },
              [
                !!message && !!message.TEXT
                  ? _c(
                      "div",
                      {
                        staticClass: "col-xs-12 alert alert-info",
                        class: {
                          "alert-success": message.TYPE === "success",
                          "alert-danger": message.TYPE === "error",
                          "alert-warning": message.TYPE === "warning"
                        },
                        attrs: {
                          role: message.TYPE === "error" ? "alert" : "status",
                          "aria-atomic": "true"
                        }
                      },
                      [_c("p", [_vm._v(_vm._s(message.TEXT))])]
                    )
                  : _vm._e()
              ]
            )
          })
        : _vm._e(),
      _vm._v(" "),
      !!_vm.selectedClass
        ? _c("student-scheduler", {
            attrs: {
              selectedStudent: _vm.selectedStudent,
              selectedCourse: _vm.selectedCourse,
              classList: _vm.classList,
              availableCourses: _vm.availableCourses,
              selectedClass: _vm.selectedClass,
              showModal: _vm.showModal,
              showConfirm: _vm.showConfirm,
              projectType: "CWP",
              canAdd: _vm.getSelectedClass.STUDENT_MAY_ADD_FLG === "Y",
              canRemove: _vm.getSelectedClass.STUDENT_MAY_DROP_FLG === "Y",
              periodDaysText: _vm.$t(
                "MAIN_CONTENT.InteractiveScheduler.periodDays"
              ),
              emptyText: _vm.$t("MAIN_CONTENT.InteractiveScheduler.empty"),
              loadingMessageText: _vm.$t(
                "MAIN_CONTENT.InteractiveScheduler.loadingMessage"
              ),
              courseConflictMessage: _vm.$t(
                "MAIN_CONTENT.InteractiveScheduler.courseConflictMessage"
              ),
              filterByText: _vm.$t(
                "MAIN_CONTENT.InteractiveScheduler.filterBy"
              ),
              allDepartmentsText: _vm.$t(
                "MAIN_CONTENT.InteractiveScheduler.allDepartments"
              ),
              showCourseDescriptionsText: _vm.$t(
                "MAIN_CONTENT.InteractiveScheduler.showCourseDesctions"
              ),
              showUnavailableClassesText: _vm.$t(
                "MAIN_CONTENT.InteractiveScheduler.showUnavailableClasses"
              ),
              confirmText: _vm.$t("commonText.confirm"),
              cancelText: _vm.$t("commonText.cancel"),
              closeText: _vm.$t("MAIN_CONTENT.commonContent.closeButton")
            },
            on: {
              loadAvailableCourses: _vm.loadAvailableCourses,
              closeModal: _vm.closeModal,
              addCourse: _vm.addCourse,
              removeCourse: _vm.removeCourse,
              updateConfirm: _vm.updateConfirm
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }